import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        classifiers: '<',
        defaultFilter: '<',
        apgView: '<',
        toggleFilter: '<',
        versions: '<'
    },
    template: `
        <form ng-if="vm.toggleFilter" ng-submit="vm.applyFilter()">
            <div class="row">
                <label class="label">{{ 'filter.Name' | translate }}</label>
                <div class="items">
                    <input ng-model="vm.filter.displayName" type="text" class="form-control">
                </div>
            </div>
            <div class="row separated">
                <label class="label">{{ 'courses.Department' | translate }}</label>
                <div class="items">
                    <div ng-dropdown-multiselect=""
                        options="vm.FilterService.departmentSelect.options"
                        selected-model="vm.FilterService.departmentSelect.models"
                        extra-settings="vm.FilterService.departmentSelect.settings"
                        events="vm.FilterService.departmentSelect.events"
                        translation-texts="vm.filterTranslations"
                    ></div>
                </div>
            </div>
            <div class="row separated">
                <label class="label">{{ 'courses.Role' | translate }}</label>
                <div class="items">
                    <div ng-dropdown-multiselect=""
                        options="vm.FilterService.roleSelect.options"
                        selected-model="vm.FilterService.roleSelect.models"
                        extra-settings="vm.FilterService.roleSelect.settings"
                        events="vm.FilterService.roleSelect.events"
                        translation-texts="vm.filterTranslations"
                    ></div>
                </div>
            </div>
            <div class="row separated">
                <label class="label">{{ 'courses.Level' | translate }}</label>
                <div class="items">
                    <div ng-dropdown-multiselect=""
                        options="vm.FilterService.levelSelect.options"
                        selected-model="vm.FilterService.levelSelect.models"
                        extra-settings="vm.FilterService.levelSelect.settings"
                        events="vm.FilterService.levelSelect.events"
                        translation-texts="vm.filterTranslations"
                    ></div>
                </div>
            </div>
            <div ng-if="vm.TokenService.isOptionalCoursesModuleEnabled() && !vm.apgView" class="row separated">
                <label class="label">{{ 'filter.Also display optional targets' | translate }}</label>
                <div class="items">
                    <label class="switch01">
                        <input type="checkbox" name="switch" ng-model="vm.filter.isOptionalTargetsIncluded">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                </div>
            </div>
            <div ng-if="vm.apgView" class="row">
                <span class="label">{{ 'filter.Include employees in automated planning group' | translate }}</span>
                <div class="items">
                    <label class="switch01 mt1em">
                        <input type="checkbox" ng-model="vm.filter.includeStartedApg">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                </div>
            </div>
            <div class="row separated">
                <label class="label">{{ 'filter.Only direct managers' | translate }}</label>
                <div class="items">
                    <label class="switch01">
                        <input type="checkbox" name="switch" ng-model="vm.filter.isOnlyDirectManagers">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'filter.Previously completed' | translate }}</label>
                <div class="items">
                    <label class="switch01">
                        <input type="checkbox" name="switch" ng-model="vm.filter.previouslyCompleted" ng-change="vm.onPreviouslyCompletedChange()">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                </div>
            </div>
            <div class="row" ng-if="vm.filter.previouslyCompleted">
                <label class="label">{{ 'filter.Completed version' | translate }}</label>
                <div class="items">
                    <select class="form-control" ng-model="vm.filter.completedVersionId"
                        ng-options="version.id as version.name for version in vm.versions">
                    <option value=""></option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="items">
                    <a class="btn main small" ng-disabled="vm.list.loading" ng-click="vm.applyFilter()">{{ 'targetedFilterButton.Filter' | translate }}</a>
                </div>
            </div>
        </form>
    `
})
export default class {
    constructor (lodash, UserService, FilterService, TokenService, CLASSIFIER_ENUM, USER_STATUS_ENUM, ROLE_CODE_ENUM) {
        this.lodash = lodash;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.TokenService = TokenService;
        this.UserService = UserService;
        this.FilterService = FilterService;
    }

    $onInit () {
        this.FilterService.init(this.classifiers);

        this.filter = angular.copy(this.defaultFilter);
        this.toggleFilter = false;

        this.filterTranslations = this.FilterService.getTranslations();
    }

    onPreviouslyCompletedChange () {
        if (!this.filter.previouslyCompleted) {
            delete this.filter.completedVersionId;
        }
    }

    applyFilter () {
        this.filter['departmentIds[]'] = this.FilterService.departmentSelect.models
            .filter((department) => department.id !== null)
            .map((department) => department.id);

        this.filter['roleIds[]'] = this.FilterService.roleSelect.models
            .filter((role) => role.id !== null)
            .map(role => role.id);

        this.filter['levelIds[]'] = this.FilterService.levelSelect.models
            .filter((level) => level.id !== null)
            .map(level => level.id);

        this.list.fetch(this.filter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/employee/targetedFilter/index.js